module.exports = __webpack_public_path__ + "img/Logo_color@2x.ca3168a0.png";